import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CLEAR_REDUX_STATE } from "../../../store/clearstore";

export const useTopBarData = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userRole = useSelector((state) => state?.auth?.type);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleUserClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserClose = () => {
    setAnchorEl(null);
  };

  const onLogout = async () => {
    localStorage.removeItem("adminLoginDetails");
    dispatch(CLEAR_REDUX_STATE.CLEAR_LOGIN_DETAILS());
    toast.success("Logout successful!");
    navigate("/admin-signin");
  };

  return {
    navigate,
    userRole,
    anchorEl,
    handleUserClick,
    handleUserClose,
    onLogout,
  };
};
